import React from 'react';

// Formats an ISO date such as 2026-10-12T00:00:00 as "Monday 12 October 2026".
// The value has no time zone on purpose (a plain calendar date), so it is shown as written.
const formatLongDate = (value) => {
    if (!value) return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    return date.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
};

// Shows the deal a venue admin set up for one person, so they can see exactly what they are
// agreeing to (price, how often, tokens and the first payment date) before they pay.
const OfferSummaryCard = ({ offer }) => {
    if (!offer) return null;

    // Pay as you go has no price, cycle or Direct Debit to describe
    if (offer.isPayAsYouGo) {
        return (
            <div className="mb-6 p-5 rounded-xl border-2 border-emerald-500/60 bg-emerald-900/20">
                <p className="text-xs uppercase tracking-wide text-emerald-400 font-semibold mb-2">Your membership offer</p>
                <h2 className="text-xl font-display font-bold text-white mb-2">Pay As You Go</h2>
                <p className="text-sm text-gray-300">No monthly payment. You pay for what you book.</p>
            </div>
        );
    }

    const firstPayment = formatLongDate(offer.nextCollectionDate);
    const price = Number(offer.cycleCost || 0).toFixed(2);

    return (
        <div className="mb-6 p-5 rounded-xl border-2 border-emerald-500/60 bg-emerald-900/20">
            <p className="text-xs uppercase tracking-wide text-emerald-400 font-semibold mb-2">
                Your membership offer
            </p>
            <h2 className="text-xl font-display font-bold text-white mb-3">{offer.subscriptionName}</h2>

            <div className="flex flex-wrap items-baseline gap-x-6 gap-y-2">
                <div>
                    <span className="text-3xl font-bold text-white">£{price}</span>
                    {offer.cycleDescription && (
                        <span className="text-gray-300 ml-2">every {offer.cycleDescription}</span>
                    )}
                </div>
                <div className="text-gray-300">
                    <span className="font-semibold text-white">{offer.tokens}</span> tokens each payment
                </div>
            </div>

            <p className="mt-4 text-sm text-gray-300">
                {firstPayment
                    ? <>Your first payment is planned for <span className="font-semibold text-white">{firstPayment}</span>.</>
                    : 'Your first payment date is confirmed when you set up your Direct Debit.'}
            </p>
            <p className="mt-1 text-xs text-gray-400">
                Payments are taken by Direct Debit through GoCardless.
            </p>
        </div>
    );
};

export default OfferSummaryCard;
